import * as React from "react";
import { Component } from "react";

import "./header.scss";

import { Search } from "../../core/components/search/search";
import { UiState } from "../../core/ui-state";
import { SearchConfiguration } from "../../core/config/search-configuration";

import { Button, Menu } from "semantic-ui-react";

import { MapState } from "../../core/map-state";
import { MapViewerConfiguration } from "../../config/map-viewer-configuration";
import { observer } from "mobx-react";
import { AppConfiguration } from "../../core/config/app-configuration";
import { runInAction } from "mobx";
import logo from "../../assets/images/kt_logo_white_inverted.svg";
import SVG from "react-inlinesvg";
import { Icon } from "../../core/components/icon/icon";
import { Link, NavLink } from "react-router-dom";
import { AuthenticationStore } from "../../stores/authentication/authentication-store";

export interface HeaderProps {
    uiStore: UiState;
    mapStore?: MapState;
    capabilities: string[];
    appConfig: AppConfiguration;
    searchConfig?: SearchConfiguration;  // widgetsSearch is also the type for configuration object
    mapViewerConfig: MapViewerConfiguration;
    authenticationStore: AuthenticationStore;
}

@observer
export class Header extends Component<HeaderProps, any> {

    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    toggleSidebarVisible(): void {
        runInAction(() => {
            const { sidebarVisible } = this.props.uiStore;
            this.props.uiStore.setSidebarVisible(!sidebarVisible);
        });
    }

    render(): JSX.Element | null {
        const { appConfig, mapStore, searchConfig, uiStore, authenticationStore } = this.props;
        const target = appConfig.target;
        const { user } = authenticationStore;

        return (
            <div className={"geo-app-header"}>
                <Menu attached="top" inverted>
                    <div className={"geo-logo"}>
                        <Menu.Item>
                            <NavLink to="/projekte">
                                <SVG src={logo} height={25} width={84}/>
                                {target !== "production" ? <span className="geo-badge geo-test-badge">Test</span> : ""}
                            </NavLink>
                        </Menu.Item>
                    </div>
                    {!user ? null :
                        <Menu.Item className={"geo-map-mobile-menu"}>
                            <Button onClick={() => this.toggleSidebarVisible()}>
                                <span className="header__mobilenavigation-button-text">Navigation</span>
                            </Button>
                        </Menu.Item>
                    }
                    <h1><span className="geo-page-title">Informationssystem Fruchtfolgeflächen</span></h1>
                    <Menu.Menu position="right">
                        {!user ? null :
                            <div className="geo-logged-in-user">
                                <Icon name={"user"} selected/>
                                <span>{user.firstName} {user.lastName} &nbsp;&nbsp;</span>
                                <Link to={"/abmelden"}>Abmelden</Link>
                            </div>
                        }
                        {this.props.capabilities.map((cap: string) => {
                            if (mapStore && cap === "search" && searchConfig) {
                                return (
                                    <Search
                                        key={cap}
                                        mapStore={mapStore}
                                        uiStore={uiStore}
                                        config={searchConfig}
                                    />
                                );
                            }
                        })
                        }
                    </Menu.Menu>
                </Menu>
            </div>
        );
    }
}
